import * as React from 'react';
import { styled, type StyledComponent } from '@glitz/react';
import { normalize } from 'nordicnest/shared/icons';

import flagAESvg from './glyphs/nn-icon-flags-AE-delivery.svg';
export const flagAE = normalize(flagAESvg);

import flagARSvg from './glyphs/nn-icon-flags-AR-delivery.svg';
export const flagAR = normalize(flagARSvg);

import flagATSvg from './glyphs/nn-icon-flags-AT-delivery.svg';
export const flagAT = normalize(flagATSvg);

import flagAUSvg from './glyphs/nn-icon-flags-AU-delivery.svg';
export const flagAU = normalize(flagAUSvg);

import flagBESvg from './glyphs/nn-icon-flags-BE-delivery.svg';
export const flagBE = normalize(flagBESvg);

import flagBRSvg from './glyphs/nn-icon-flags-BR-delivery.svg';
export const flagBR = normalize(flagBRSvg);

import flagCASvg from './glyphs/nn-icon-flags-CA-delivery.svg';
export const flagCA = normalize(flagCASvg);

import flagCHSvg from './glyphs/nn-icon-flags-CH-delivery.svg';
export const flagCH = normalize(flagCHSvg);

import flagCNSvg from './glyphs/nn-icon-flags-CN-delivery.svg';
export const flagCN = normalize(flagCNSvg);

import flagCZSvg from './glyphs/nn-icon-flags-CZ-delivery.svg';
export const flagCZ = normalize(flagCZSvg);

import flagDESvg from './glyphs/nn-icon-flags-DE-delivery.svg';
export const flagDE = normalize(flagDESvg);

import flagDKSvg from './glyphs/nn-icon-flags-DK-delivery.svg';
export const flagDK = normalize(flagDKSvg);

import flagEESvg from './glyphs/nn-icon-flags-EE-delivery.svg';
export const flagEE = normalize(flagEESvg);

import flagESSvg from './glyphs/nn-icon-flags-ES-delivery.svg';
export const flagES = normalize(flagESSvg);

import flagFISvg from './glyphs/nn-icon-flags-FI-delivery.svg';
export const flagFI = normalize(flagFISvg);

import flagFRSvg from './glyphs/nn-icon-flags-FR-delivery.svg';
export const flagFR = normalize(flagFRSvg);

import flagGRSvg from './glyphs/nn-icon-flags-GR-delivery.svg';
export const flagGR = normalize(flagGRSvg);

import flagHKSvg from './glyphs/nn-icon-flags-HK-delivery.svg';
export const flagHK = normalize(flagHKSvg);

import flagHRSvg from './glyphs/nn-icon-flags-HR-delivery.svg';
export const flagHR = normalize(flagHRSvg);

import flagHUSvg from './glyphs/nn-icon-flags-HU-delivery.svg';
export const flagHU = normalize(flagHUSvg);

import flagIESvg from './glyphs/nn-icon-flags-IE-delivery.svg';
export const flagIE = normalize(flagIESvg);

import flagILSvg from './glyphs/nn-icon-flags-IL-delivery.svg';
export const flagIL = normalize(flagILSvg);

import flagINSvg from './glyphs/nn-icon-flags-IN-delivery.svg';
export const flagIN = normalize(flagINSvg);

import flagITSvg from './glyphs/nn-icon-flags-IT-delivery.svg';
export const flagIT = normalize(flagITSvg);

import flagJPSvg from './glyphs/nn-icon-flags-JP-delivery.svg';
export const flagJP = normalize(flagJPSvg);

import flagKRSvg from './glyphs/nn-icon-flags-KR-delivery.svg';
export const flagKR = normalize(flagKRSvg);

import flagLTSvg from './glyphs/nn-icon-flags-LT-delivery.svg';
export const flagLT = normalize(flagLTSvg);

import flagLUSvg from './glyphs/nn-icon-flags-LU-delivery.svg';
export const flagLU = normalize(flagLUSvg);

import flagLVSvg from './glyphs/nn-icon-flags-LV-delivery.svg';
export const flagLV = normalize(flagLVSvg);

import flagMXSvg from './glyphs/nn-icon-flags-MX-delivery.svg';
export const flagMX = normalize(flagMXSvg);

import flagMYSvg from './glyphs/nn-icon-flags-MY-delivery.svg';
export const flagMY = normalize(flagMYSvg);

import flagNLSvg from './glyphs/nn-icon-flags-NL-delivery.svg';
export const flagNL = normalize(flagNLSvg);

import flagNOSvg from './glyphs/nn-icon-flags-NO-delivery.svg';
export const flagNO = normalize(flagNOSvg);

import flagNZSvg from './glyphs/nn-icon-flags-NZ-delivery.svg';
export const flagNZ = normalize(flagNZSvg);

import flagPHSvg from './glyphs/nn-icon-flags-PH-delivery.svg';
export const flagPH = normalize(flagPHSvg);

import flagPLSvg from './glyphs/nn-icon-flags-PL-delivery.svg';
export const flagPL = normalize(flagPLSvg);

import flagPTSvg from './glyphs/nn-icon-flags-PT-delivery.svg';
export const flagPT = normalize(flagPTSvg);

import flagROSvg from './glyphs/nn-icon-flags-RO-delivery.svg';
export const flagRO = normalize(flagROSvg);

import flagRUSvg from './glyphs/nn-icon-flags-RU-delivery.svg';
export const flagRU = normalize(flagRUSvg);

import flagSESvg from './glyphs/nn-icon-flags-SE-delivery.svg';
export const flagSE = normalize(flagSESvg);

import flagSGSvg from './glyphs/nn-icon-flags-SG-delivery.svg';
export const flagSG = normalize(flagSGSvg);

import flagSISvg from './glyphs/nn-icon-flags-SI-delivery.svg';
export const flagSI = normalize(flagSISvg);

import flagSKSvg from './glyphs/nn-icon-flags-SK-delivery.svg';
export const flagSK = normalize(flagSKSvg);

import flagTRSvg from './glyphs/nn-icon-flags-TR-delivery.svg';
export const flagTR = normalize(flagTRSvg);

import flagTWSvg from './glyphs/nn-icon-flags-TW-delivery.svg';
export const flagTW = normalize(flagTWSvg);

import flagUASvg from './glyphs/nn-icon-flags-UA-delivery.svg';
export const flagUA = normalize(flagUASvg);

import flagUKSvg from './glyphs/nn-icon-flags-UK-delivery.svg';
export const flagUK = normalize(flagUKSvg);

import flagUSSvg from './glyphs/nn-icon-flags-US-delivery.svg';
export const flagUS = normalize(flagUSSvg);

export function getCurrentFlagByCountry(country: string): StyledComponent<React.SVGAttributes<SVGElement>> {
  switch (country) {
    case 'AE':
      return flagAE;
    case 'AR':
      return flagAR;
    case 'AT':
      return flagAT;
    case 'AU':
      return flagAU;
    case 'BE':
      return flagBE;
    case 'BR':
      return flagBR;
    case 'CA':
      return flagCA;
    case 'CH':
      return flagCH;
    case 'CZ':
      return flagCZ;
    case 'DE':
      return flagDE;
    case 'DK':
      return flagDK;
    case 'EE':
      return flagEE;
    case 'ES':
      return flagES;
    case 'FI':
      return flagFI;
    case 'FR':
      return flagFR;
    case 'GR':
      return flagGR;
    case 'HK':
      return flagHK;
    case 'HR':
      return flagHR;
    case 'HU':
      return flagHU;
    case 'IE':
      return flagIE;
    case 'IL':
      return flagIL;
    case 'IN':
      return flagIN;
    case 'IT':
      return flagIT;
    case 'JP':
      return flagJP;
    case 'KR':
      return flagKR;
    case 'LT':
      return flagLT;
    case 'LU':
      return flagLU;
    case 'LV':
      return flagLV;
    case 'MX':
      return flagMX;
    case 'MY':
      return flagMY;
    case 'NL':
      return flagNL;
    case 'NO':
      return flagNO;
    case 'NZ':
      return flagNZ;
    case 'PH':
      return flagPH;
    case 'PL':
      return flagPL;
    case 'PT':
      return flagPT;
    case 'RO':
      return flagRO;
    case 'RU':
      return flagRU;
    case 'SE':
      return flagSE;
    case 'SG':
      return flagSG;
    case 'SI':
      return flagSI;
    case 'SK':
      return flagSK;
    case 'TR':
      return flagTR;
    case 'TW':
      return flagTW;
    case 'UA':
      return flagUA;
    case 'UK':
      return flagUK;
    case 'US':
      return flagUS;
    default:
      return styled(() => null);
  }
}
